import { VolumeDiscountMapper } from '../../../models/VolumeDiscount/VolumeDiscountMapper.js';

class VolumeDiscountRepository {
  constructor(apiClient) {
    this.apiClient = apiClient;
  }
  getClientRates() {
    return this.apiClient.get('v1/volume-discount/clients/rates').then(response => response.data.map(rateResponse => VolumeDiscountMapper.createRateFromResponse(rateResponse)));
  }
  getIsEstimated() {
    return this.apiClient.get('v1/volume-discount/clients').then(response => response.data.volume_band_estimated);
  }
  getBands() {
    return this.apiClient.get('v1/volume-discount/volumebands').then(response => response.data.map(bandResponse => VolumeDiscountMapper.createBandFromResponse(bandResponse)));
  }
  createEstimate(volumeBand) {
    return this.apiClient.post('v1/volume-discount/clients/estimate', VolumeDiscountMapper.createBandApiPayload(volumeBand)).then(response => response.data);
  }
}

export { VolumeDiscountRepository };
//# sourceMappingURL=VolumeDiscountRepository.js.map
